export const APP_THEME_STORAGE_KEY = "lingulink-app-theme";

export const DEFAULT_THEME_NAME = "zinc-light";

/** Removed themes: map old localStorage values to current names */
const LEGACY_THEME_NAMES: Record<string, string> = {
  rockads: "zinc-light",
  "rockads-dark": "zinc-dark",
};

const normalizeStoredThemeName = (raw: string | null): string => {
  if (!raw) {
    return DEFAULT_THEME_NAME;
  }
  return LEGACY_THEME_NAMES[raw] ?? raw;
};

export const getStoredThemeName = (): string => {
  if (typeof window === "undefined") {
    return DEFAULT_THEME_NAME;
  }
  try {
    const raw = window.localStorage.getItem(APP_THEME_STORAGE_KEY);
    return normalizeStoredThemeName(raw);
  } catch {
    return DEFAULT_THEME_NAME;
  }
};

export const persistThemeName = (name: string): void => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(APP_THEME_STORAGE_KEY, name);
  } catch {
    // Ignore storage errors (private mode, quota, etc.)
  }
};

/** Rewrites localStorage when it still references a removed theme name */
export const migrateLegacyThemeInStorage = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    const raw = window.localStorage.getItem(APP_THEME_STORAGE_KEY);
    if (!raw) {
      return;
    }
    const next = LEGACY_THEME_NAMES[raw];
    if (next) {
      window.localStorage.setItem(APP_THEME_STORAGE_KEY, next);
    }
  } catch {
    // Ignore storage errors
  }
};
